export default __webpack_public_path__ + "static/media/LAPIZ LAZULI.9696f2ef.jpg";